module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02a"
    }
  }, [_c('a', {
    attrs: {
      "id": "page02"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("With Valentine’s Day coming up, it’s the perfect opportunity to indulge in some romance, and where better than with eight new fantastic Harlequin Presents"), _c('sup', [_vm._v("®")]), _vm._v(" stories!")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("This month we have bestselling author Lynne Graham with the second book in her PREGNANT BRIDES trilogy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ruthless Magnate, Convenient Wife.")]), _vm._v(" Get whisked away to the stunning Moscow where ruthless billionaire Sergei Antonovich will stop at nothing to make the shy and virginal Alissa his convenient wife!")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("And please help us celebrate Carole Mortimer’s 150th book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Infamous Italian’s Secret Baby.")]), _vm._v(" When one night leads to one baby, Bella Scott finds herself at the mercy of infamous Gabriel Danti!")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Why not treat yourself with a wonderful story of blackmail in Robyn Donald’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rich Man’s Blackmailed Mistress.")]), _vm._v(" And Talos Xenakis’s plans for revenge change when he discovers his mistress is pregnant in Jennie Lucas’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bought: The Greek’s Baby.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Out this month is our first book in the BRIDE ON APPROVAL miniseries. Whether bought, sold, bargained for or bartered, these brides have no choice but to say I do. Be sure not to miss Caitlin Crews’s debut book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pure Princess, Bartered Bride.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Who will reunite the two Stefani diamonds, and become ruler? Find out in the last installment of THE ROYAL HOUSE OF KAREDES, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Desert King’s Housekeeper Bride")]), _vm._v(" by Carol Marinelli. But the saga continues in April with DARK-HEARTED DESERT MEN. Four brooding sheikhs with a hint of Karedes in them.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("And last, but by no means least, don’t forget about any of our fabulous new miniseries coming out in 2010. The glamour, the excitement, the intensity just keep getting better.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_vm._v("Wow! 2010—this truly is the year of Presents! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Your everyday luxury.")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page02"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65d7fc3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/boughtthegreeksbaby_fm02a.vue
// module id = 60
// module chunks = 0